import { type FC } from 'react';
import { DASHBOARD_TODO_LIST_FEATURE_HINT_IDS } from '#shared/lib/featureHints';
import { readDashboardTodoListMainExpanded } from './lib/dashboardTodoListMainExpandedStorage';
import {
    type DashboardTodoListFeatureHintEligibility,
    useDashboardTodoListFeatureHints,
} from './useDashboardTodoListFeatureHints';

const PENDING_ELIGIBILITY = {
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.TITLE]: 'pending',
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.COMPLETION_ICON]: 'pending',
    [DASHBOARD_TODO_LIST_FEATURE_HINT_IDS.NEW_LABEL]: 'pending',
} satisfies DashboardTodoListFeatureHintEligibility;

const PendingFeatureHintsRegistration: FC = () => {
    useDashboardTodoListFeatureHints(PENDING_ELIGIBILITY);

    return null;
};

/**
 * Сохраняет место Dashboard-подсказок в общей очереди, пока загружаются страница или данные чек-листа.
 * Сам компонент ничего не показывает: он сообщает, что условия подсказок ещё вычисляются,
 * поэтому порядок автоматических показов не зависит от скорости загрузки. Для свёрнутого чек-листа
 * регистрация не создаётся, поскольку его подсказки всё равно не могут появиться.
 *
 * @kind component
 */
export const DashboardTodoListFeatureHintsPendingRegistration: FC = () => {
    if (!readDashboardTodoListMainExpanded()) {
        return null;
    }

    return <PendingFeatureHintsRegistration />;
};
